import {Component, Input} from '@angular/core';
import { FormGroup } from '@angular/forms';
import {Donation} from "../donation/donation";
import {PaymentComponent} from "../payment/payment.component";
import {ContactComponent} from "../contact/contact.component";
import {Contact} from "../contact/contact";
import {OptionService} from "../option/option.service";

/**
 * This component is used so send data to external (payment) partners to use the form.submit() event as window opener
 * and do not have a popup
 */
@Component({
    selector: 'hidden-formsubmit',
    templateUrl: './input.hidden.formsubmit.component.html'
})
export class HiddenFormsubmitComponent {
    /**
     * The ID of the field
     */
    @Input() id: string;

    /**
     * form that is used for validation
     */
    @Input() form: FormGroup;

    /**
     * The donation object
     */
    @Input() donation: Donation;

    /**
     * receives the contact data that the user puts in
     */
    @Input() contact: Contact;

    /**
     * The current Step
     */
    @Input() step: string;

    /**
     * The current screensize
     */
    @Input() size: string;

    /**
     * The current type of the app
     */
    @Input() type: string;

    /**
     * Returns the value (stringified donation) but only if a redirect is needed
     * @returns {any}
     */
    getValue(): string {
        // 1. check if the form is valid and we have a payment method that needs a external redirect
        if(this.form.valid && PaymentComponent.redirectPaymentMethods.indexOf(this.donation.paymentMethod) != -1) {

            let contactMandatory = ContactComponent.isContactMandatory();

            // 2. check if we are on a small device and on step payment
            if(this.step == "payment") {
                return this.getDonationData();
            }
            else if(contactMandatory == true && this.size != "small" && this.type != "widget" && this.step == "contact-mandatory") {
                return this.getDonationData();
            }
            else if(this.type == "form" && this.step == "start") {
                return this.getDonationData();
            }
            else if(this.size != "small" && this.step == "start" && this.type != "widget" && contactMandatory == false){
                // 3. otherwise we are on a none-small device and on the start step
                return this.getDonationData();
            }
        }
        return "";
    }

    /**
     * returns the stringified donation data
     * @returns {string}
     */
    getDonationData(): string {
        // add the contact data
        this.donation.contactData = this.contact;
        return JSON.stringify(this.donation);
    }

}
